import React from 'react';
import { cn } from '@/lib/utils';
import { BrandMark } from '@/components/ui/brand-mark';
import { logoFor, logoSrc } from '@/lib/brand-logos';

/**
 * Destination marks, from the brands' own files (lib/brand-logos, sources in
 * public/logos/SOURCES.md). Meta and Google Ads used to be redrawn here as
 * inline SVG, and the redrawings were wrong (owner, 8 Oct 2026: "the meta
 * logo, google ads logo, GA4 logo are incorrect"). A plain image at the size
 * asked for, no tile, so it sits inline beside text like an icon.
 */
const FILE_OF = {
  meta: 'meta', meta_capi: 'meta',
  google_ads: 'google-ads', google: 'google-ads', google_ads_click: 'google-ads', google_dm: 'google-ads',
  ga4: 'google-analytics', sgtm: 'google-tag-manager', google_sheets: 'google-sheets',
};
const NAME_OF = { meta: 'Meta', google_ads: 'Google Ads', google: 'Google Ads', ga4: 'GA4', sgtm: 'Server GTM' };

export function PlatformLogo({ platform, className, title }) {
  const cls = cn('inline-block shrink-0 align-[-2px] object-contain', className || 'size-4');
  const logo = logoFor(FILE_OF[platform] || platform);
  if (logo && logo.fit !== 'bleed' && !logo.bg) {
    return <img src={logoSrc(logo)} alt={title || NAME_OF[platform] || platform} className={cls} draggable={false} />;
  }
  // A brand whose file is an app-icon square (or needs its own ground) keeps
  // the small tile it was made for.
  if (logo) return <BrandMark brand={FILE_OF[platform] || platform} name={title || platform} size="xs" className={cn('rounded-[4px] border-0', className || 'size-4')} />;
  return <span className={cn('rounded bg-muted px-1 font-sans text-[12px] font-semibold text-muted-foreground', className)}>{title || platform}</span>;
}

export const PLATFORM_COLOR = { meta: '#0866FF', google_ads: '#34A853' };
